/** CheckButton parser: Button's parse plus `button_pressed`. check_button.cpp binds no property, and its constructor only sets toggle_mode=true. */
import { parseButton } from '../button/parser';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
export function parseCheckButton(heading, properties) {
    const result = { ...parseButton(heading, properties) };
    result.buttonPressed = boolSlotValue(properties.button_pressed) === true;
    return result;
}
//# sourceMappingURL=parser.js.map